const NotFound = () => {
  return (
    <div className="page flex flex-dc flex-jc" style={{ fontSize: '50px' }}>
      404
    </div>
  )
}
export default NotFound
